<!--
    allData         -> datos en acomotel + prvh
    initialData     -> datos en prvh
    optiosList      -> allData.asigned = false
    tableList       -> allData.asigned = true
-->
<template>
    <div class="panel panel-default" style="margin-left:30px; margin-right:30px;">
        <div class="container-fluid">

            <div class="row">
                <div class="col-md-12">
                    <h3>{{ title }} </h3>
                </div>
            </div>

            <div class="row">
                <div class="col-md-4">
                    <model-list-select
                            :list="optionsList"
                            :custom-text="customComboText"
                            option-value="id"
                            v-model="optionSelected"
                            placeholder="-- Elije una tarifa --"
                    >
                    </model-list-select>
                </div>

                <div class="col-md-1">
                    <button class="ml-1 btn btn-primary"
                            type="submit"
                            :disabled="!optionSelected"
                            @click="addDelLine(optionSelected)"
                    >
                        A&ntilde;adir
                    </button>
                </div>

                <div class="col-md-7">
                    <div v-show="alertMessage !== ''" :class="getClass()" role="alert">
                        {{ alertMessage }}
                    </div>
                </div>

            </div>

            <div class="row">
                <div class="col-lg-9 col-md-9"></div>
                <div v-if="getPages > 1" class="col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <select class="form-control" v-model="pageSize" v-if="totalAdds > 5">
                        <option value="5">5 por página</option>
                        <option value="10">10 por página</option>
                        <option value="25">25 por página</option>
                        <option value="50">50 por página</option>
                        <option value="100">100 por página</option>
                    </select>
                </div>
            </div>

            <table class="table table-hover">
                <thead>
                <tr>
                    <th width="10%">Id</th>
                    <th>{{ titleSingular }}</th>
                    <th>Descripción</th>
                    <th>Grupo de Tarifa</th>
                    <th>Acciones</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(line) in tableList" :key="line.id">
                    <td>{{ line.id }}</td>
                    <td>{{ line.code }}</td>
                    <td>{{ line.description }}</td>
                    <td>
                        <input v-model="line.rateGroup" @blur="changeGroup"/>
                    </td>
                    <td class="actions">
                        <button type="button" @click="addDelLine(line.id)" class="btn btn-danger">
                            <i class="fas fa-trash-alt"></i>
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>

            <nav class="pull-right" v-if="getPages > 1">
                <paginate
                        v-model="page"
                        :page-count="getPages"
                        :click-handler="onPageChange"
                        :prev-text="'<'"
                        :next-text="'>'"
                        :container-class="'pagination'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :prev-class="'page-item'"
                        :next-class="'page-item'"
                        :prev-link-class="'page-link'"
                        :next-link-class="'page-link'"
                        :active-class="'active'">
                </paginate>
            </nav>

            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-lg-5 col-md-5">
                                {{ title }} a&ntilde;adidas
                                <span class="badge">{{ totalAdds }}</span>
                            </div>

                            <div class="col-lg-4 col-md-4"></div>

                            <div class="col-lg-3 col-md-3">
                                <button class="btn btn-primary pull-right"
                                        type="submit"
                                        :disabled="!enabledSave"
                                        @click="saveList"
                                >
                                    Guardar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    import {mapState, mapMutations} from "vuex";

    import Paginate from 'vuejs-paginate'
    import { ModelListSelect } from 'vue-search-select';

    export default {
        name: 'data-list',
        components: {
            Paginate,
            ModelListSelect,
        },
        props: {
            title: String,
            methodOptions: String,
            methodList: String,
            methodSave: String,
        },
        data () {
            return {
                errorCode: 0,
                context: 'DirectProductConfig/DirectProductController/',
                total: 0,
                page: 1,
                pageSize: 5,
                optionSelected: '',
                initialData: [],
                allData: [],
                enabledSave: false,
                alertMessage: '',
                alertStyle: true
            };
        },
        computed: {
            ...mapState('DirectProduct',['storeAgency','storeHotel']),

            getPages() {
                let pages = 1;
                if(this.totalAdds > 0) {
                    pages = Math.ceil(this.totalAdds / this.pageSize)
                }
                return pages
            },
            optionsList() {
                return this.allData.filter(e => e.assigned === false);
            },
            tableList() {
                let allList = this.allData.filter(e => e.assigned === true);
                let pageList = allList.slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
                return pageList;
            },
            totalAdds() {
                let allList = this.allData.filter(e => e.assigned === true);
                return allList.length;
            },
            titleSingular() {
                return this.title.slice(0,-1);
            },
            titleLowercase() {
                return this.title.toLowerCase();
            }
        },
        methods: {
            ...mapMutations('DirectProduct',['fillHasModified']),

            customComboText (item) {
                return `${item.code} - ${item.description}`
            },
            loadData() {
                this.resetResults();
                let fnOptionsList = this.getOptionsList();
                let fnDataList = this.getDataList();

                Promise.all([
                    fnOptionsList,
                    fnDataList
                ]).then(values => {
                    let self = this;
                    let allOk = true;
                    this.initialData.forEach(function (itemInitialData) {
                        let foundIndex = self.allData.findIndex(x => x.id == itemInitialData.id);
                        if (foundIndex != -1) {
                            self.allData[foundIndex].assigned = true;
                            self.allData[foundIndex].rateGroup = itemInitialData.rateGroup;
                        } else {
                            let formattedData = {
                                'id': itemInitialData.id,
                                'agencyId': self.storeAgency.id,
                                'accomId': self.storeHotel.id,
                                'hotel': self.storeHotel.name,
                                'code': "???",
                                'description': "???",
                                'assigned': true,
                                'rateGroup': itemInitialData.rateGroup
                            };
                            self.allData.push(formattedData);
                            allOk = false;
                        }
                    });

                    if (!allOk) {
                        this.alertMessage = 'Hay '+ this.titleLowercase + ' configuradas que han dejado de existir, consultar si se trata de un error'
                    }
                }).catch((error) => {
                    this.errorCode = error.error_code;
                    this.scrollToTop();
                }).finally((data) => {
                    //this.$store.dispatch('endLoading');
                    //this.scrollToTop();
                });
            },
            getOptionsList() {
                return new Promise((resolve,reject) => {
                    this.$http.get(this.context + this.methodOptions, {
                        params: {
                            accommodationId: this.storeHotel.id
                        }
                    }).then(({data}) => {
                        let listData = data.data;

                        for (let accomodations in listData) {

                            for (let i in listData[accomodations]) {
                                let id = listData[accomodations][i].id;
                                let code = listData[accomodations][i].code;
                                let description = listData[accomodations][i].description;
                                let formattedData = {
                                    'id': id,
                                    'agencyId': this.storeAgency.id,
                                    'accomId': this.storeHotel.id,
                                    'hotel': this.storeHotel.name,
                                    'code': code,
                                    'description': description,
                                    'assigned': false,
                                    'rateGroup': ''
                                };
                                this.allData.push(formattedData);
                            }
                        }

                        resolve(true);
                    }).catch( error => {
                        reject(error);
                    });
                });
            },
            getDataList() {
                return new Promise((resolve,reject) => {
                    this.$http.get(this.context + this.methodList, {
                        params: {
                            agencyId: this.storeAgency.id,
                            accommodationId: this.storeHotel.id,
                            rateGroup: 'all'
                        }
                    }).then(({data}) => {
                        this.initialData = [];
                        let listData = data.data;

                        for (let i in listData) {
                            let id = listData[i].id;
                            let rateGroup = listData[i].rateGroup;
                            let formattedData = {
                                'id': id,
                                'rateGroup': rateGroup
                            };
                            this.initialData.push(formattedData);
                        }

                        resolve(true);
                    }).catch( error => {
                        reject(error);
                    });
                });
            },
            addDelLine(id) {
                let foundIndex = this.allData.findIndex(x => x.id == id);
                this.allData[foundIndex].assigned = !this.allData[foundIndex].assigned;
                this.optionSelected = '';
                // si borra item ult. pag con 1 solo item vuelva a ult pag nueva
                if (this.page > this.getPages) {
                    this.page = this.getPages;
                }
                this.getChanges();
            },
            saveList() {
                let changes = this.getChanges();

                return new Promise((resolve,reject) => {

                    this.$http.get(this.context + this.methodSave, {
                        params: {
                            agencyId: this.storeAgency.id,
                            addedData: JSON.stringify(changes.listAdded),
                            deletedData: JSON.stringify(changes.listDeleted),
                            changedData: JSON.stringify(changes.listChanged),
                        }
                    }).then(({data}) => {

                        if (data.result) {
                            this.alertStyle = false;
                            this.alertMessage = data.data[0];
                            let self = this;
                            setTimeout(function () {
                                self.alertMessage = '';
                                self.reinitializeData();
                            }, 5000);
                        } else {
                            this.alertMessage = data.data.error_message;
                        }

                        this.enabledSave = false;

                        resolve(true);
                    }).catch( error => {
                        reject(error);
                    });
                });
            },
            getChanges() {
                let listAdded = [];
                let listDeleted = [];
                let listChanged = [];
                let found = null;
                let self = this;

                this.allData.forEach(function (itemAllData) {
                    found = self.initialData.findIndex(x => x.id == itemAllData.id);
                    if (itemAllData.assigned) {
                        if (found == -1) {
                            listAdded.push(itemAllData);
                        } else {
                            if (itemAllData.rateGroup != self.initialData[found].rateGroup) {
                                listChanged.push(itemAllData);
                            }
                        }
                    } else {
                        if (found != -1) {
                            listDeleted.push(itemAllData);
                        }
                    }
                });

                this.enabledSave = (
                    listAdded.length || listDeleted.length || listChanged.length
                ) ? true : false;

                let isModified = {
                    "data": this.titleLowercase,
                    "value": this.enabledSave
                };
                this.fillHasModified(isModified);

                return {
                    "listAdded": listAdded,
                    "listDeleted": listDeleted,
                    "listChanged": listChanged
                }
            },
            changeGroup() {
                this.getChanges();
            },

            getClass() {
                if (this.alertStyle) {
                    return 'alert alert-danger';
                } else {
                    return 'alert alert-success';
                }
            },
            reinitializeData() {
                this.initialData = this.allData.filter(e => e.assigned === true).map(el => ({...el}));
                this.enabledSave = false;
                this.fillHasModified({
                    "data": this.titleLowercase,
                    "value": this.enabledSave
                });

            },
            // en destinia esta en common
            scrollToTop() {
                window.scrollTo(0,0);
            },
            onPageChange(page) {
                this.page = page;
            },
            resetResults() {
                this.page = 1;
                this.initialData = [];
                this.optionSelected = '';
                this.allData = [];
                this.enabledSave = false;
                this.alertMessage = '';
                this.alertStyle = true;
            },
        },
        watch: {
            errorCode () {
                if(this.errorCode !== 0) {
                    let errorMsg ="Ha ocurrido un error";
                    this.$store.dispatch('setMessageError', errorMsg);
                }
            },
            'storeHotel.id': function (newVal, oldVal){
                if (newVal !== null && typeof newVal !== 'undefined') {
                    this.loadData();
                }
             },             
        }
    }
</script>

<style scoped>
</style>